/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class CampaignTemplateGrid extends NoboxEntityGrid<CampaignTemplateRow, any> {
        protected getColumnsKey() { return CampaignTemplateColumns.columnsKey; }
        protected getDialogType() { return CampaignTemplateDialog; }
        protected getIdProperty() { return CampaignTemplateRow.idProperty; }
        protected getInsertPermission() { return CampaignTemplateRow.insertPermission; }
        protected getLocalTextPrefix() { return CampaignTemplateRow.localTextPrefix; }
        protected getService() { return CampaignTemplateService.baseUrl; }
        constructor(container: JQuery) {
            super(container);
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            return true;
        }
    }
}